(() => {
  function init(root) {
    if (root.dataset.cfReady) return;
    root.dataset.cfReady = 'true';
    const reviewJump = root.querySelector('.cf-review-jump');
    const reviews = root.querySelector('#CFReviews');
    const syncReviews = () => {
      const hasReviews = !!root.querySelector('.cf-rating[data-cf-review-count]') || [...root.querySelectorAll('[data-areviews-count]')].some(node => Number(node.getAttribute('data-areviews-count')) > 0 && node.getAttribute('data-areviews-product-page-no-reviews') !== '1');
      if (reviewJump) reviewJump.hidden = !hasReviews;
      if (reviews) reviews.hidden = !hasReviews;
    };
    syncReviews();
    new MutationObserver(syncReviews).observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['data-areviews-count','data-areviews-product-page-no-reviews']});
    const variants = JSON.parse(root.querySelector('[data-cf-variants]').textContent);
    const strings = JSON.parse(root.querySelector('[data-cf-product-strings]').textContent);
    const description = root.querySelector('[data-cf-description]');
    if (description) {
      description.classList.remove('cf-description--collapsed');
      const toggle = description.querySelector('[data-cf-description-toggle]');
      const close = description.querySelector('[data-cf-description-close]');
      if (toggle) { toggle.hidden = true; toggle.setAttribute('aria-expanded','true'); }
      if (close) close.hidden = true;
    }
    const select = root.querySelector('[data-cf-variant]');
    const add = root.querySelector('[data-cf-add]');
    const addText = add.querySelector('[data-cf-add-text]');
    const payment = root.querySelector('[data-cf-payment]');
    const price = root.querySelector('[data-cf-price]');
    const compare = root.querySelector('[data-cf-compare]');
    const inventory = JSON.parse(root.querySelector('[data-cf-inventory]')?.textContent || '{}');
    const saving = root.querySelector('[data-cf-saving]');
    const stock = root.querySelector('[data-cf-stock]');
    function updateUrgency(variant) {
      const delivery = root.querySelector('[data-cf-delivery]');
      if (delivery) delivery.hidden = !variant?.available;
      if (saving) {
        saving.hidden = !variant || !(variant.compare_at_price > variant.price);
        if (!saving.hidden) {
          saving.querySelector('[data-cf-saving-amount]').textContent = new Intl.NumberFormat(strings.locale,{style:'currency',currency:strings.currency,currencyDisplay:'narrowSymbol'}).format((variant.compare_at_price - variant.price)/100);
          saving.querySelector('[data-cf-saving-percent]').textContent = Math.round((variant.compare_at_price - variant.price)*100/variant.compare_at_price);
        }
      }
      if (stock) {
        const item = variant && inventory[variant.id];
        stock.hidden = !(variant?.available && item?.tracked && item.policy === 'deny' && item.quantity > 0);
        stock.classList.toggle('cf-stock--available', item?.quantity > 5);
        if (!stock.hidden) stock.querySelector('[data-cf-stock-text]').textContent = item.quantity > 5 ? strings.in_stock : strings.stock.replace('__COUNT__',item.quantity);
      }
    }
    const status = root.querySelector('[data-cf-status]');
    const track = root.querySelector('[data-cf-gallery-track]');
    const slides = [...root.querySelectorAll('[data-cf-zoom]')];
    const thumbs = [...root.querySelectorAll('[data-cf-image]')];
    let galleryIndex = Math.max(0,slides.findIndex(slide => slide.hasAttribute('data-cf-initial')));
    const money = value => strings.currency + ' ' + new Intl.NumberFormat(strings.locale, {style:'currency',currency:strings.currency,currencyDisplay:'narrowSymbol'}).format(value / 100);
    function syncGallery(index) {
      galleryIndex = index;
      thumbs.forEach((button,i) => { if (i === index) button.setAttribute('aria-current','true'); else button.removeAttribute('aria-current'); });
      const count = root.querySelector('[data-cf-gallery-count]');
      if (count) count.textContent = (index+1)+' / '+slides.length;
      root.querySelectorAll('[data-cf-gallery-step]').forEach(button => button.disabled = Number(button.dataset.cfGalleryStep)<0 ? index === 0 : index === slides.length-1);
    }
    function goToSlide(index,instant) {
      index = Math.max(0,Math.min(slides.length-1,index));
      if (!track || !slides[index]) return;
      track.scrollTo({left:slides[index].offsetLeft-track.offsetLeft,behavior:instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      syncGallery(index);
    }
    function image(url, full, button) {
      const mediaId = button?.dataset.cfMediaId;
      const base = value => value.split('?')[0].split('/').pop();
      const index = slides.findIndex(slide => mediaId ? slide.dataset.cfMediaId === mediaId : base(slide.href) === base(full || url));
      if (index >= 0) goToSlide(index);
    }
    thumbs.forEach(button => button.addEventListener('click',() => image(button.dataset.cfImage,button.dataset.cfFull,button)));
    root.querySelectorAll('[data-cf-gallery-step]').forEach(button => button.addEventListener('click',() => goToSlide(galleryIndex+Number(button.dataset.cfGalleryStep))));
    if (track) {
      track.addEventListener('scroll',() => {
        const index = Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));
        syncGallery(index);
      },{passive:true});
      track.addEventListener('keydown',event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); goToSlide(galleryIndex+(event.key === 'ArrowRight' ? 1 : -1)); }
      });
      requestAnimationFrame(() => goToSlide(galleryIndex,true));
    }
    const options = [...root.querySelectorAll('[data-cf-option]')];
    if (options.length) {
      root.classList.add('cf-product--enhanced');
      options.forEach(option => option.addEventListener('change', () => {
        const values = [...root.querySelectorAll('.cf-options fieldset')].map(field => field.querySelector('select')?.value ?? field.querySelector('input:checked')?.value);
        const colour = root.querySelector('[data-cf-colour]');
        if (colour) colour.textContent = values[0].charAt(0).toUpperCase() + values[0].slice(1);
        const variant = variants.find(v => v.options.every((value, i) => value === values[i]));
        add.disabled = !variant?.available;
        updateUrgency(variant);
        if (payment) payment.hidden = !variant?.available;
        (addText || add).textContent = variant ? (variant.available ? strings.add : strings.sold_out) : strings.unavailable;
        if (!variant) { select.disabled = true; status.textContent = strings.unavailable; return; }
        select.disabled = false;
        select.value = String(variant.id);
        select.dispatchEvent(new Event('change', {bubbles:true}));
        price.textContent = money(variant.price);
        compare.hidden = !(variant.compare_at_price > variant.price);
        compare.textContent = variant.compare_at_price ? money(variant.compare_at_price) : '';
        status.textContent = variant.available ? '' : strings.sold_out;
        if (variant.featured_image?.src) image(variant.featured_image.src, variant.featured_image.src);
        const url = new URL(location.href);
        url.searchParams.set('variant',variant.id);
        history.replaceState({},'',url);
      }));
    } else if (variants.length === 1) root.classList.add('cf-product--enhanced');
    root.querySelectorAll('[data-cf-quantity]').forEach(button => button.addEventListener('click', () => {
      const input = root.querySelector('input[name="quantity"]');
      const increment = Number(input.step) || 1;
      const next = (Number(input.value) || Number(input.min) || 1) + Number(button.dataset.cfQuantity) * increment;
      input.value = Math.max(Number(input.min) || 1, Math.min(Number(input.max) || Infinity,next));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }));
    const policy = root.querySelector('[data-cf-policy-modal]');
    root.querySelector('[data-cf-policy-open]')?.addEventListener('click',event => {
      if (!policy?.showModal) return;
      event.preventDefault();
      policy.showModal();
    });
    policy?.querySelector('[data-cf-policy-close]')?.addEventListener('click',() => policy.close());
    policy?.addEventListener('click',event => { if (event.target === policy) policy.close(); });
    const dialog = root.querySelector('.cf-lightbox');
    root.querySelectorAll('[data-cf-open-video]').forEach(button => button.addEventListener('click',() => {
      const modal = document.getElementById(button.dataset.cfOpenVideo);
      if (!modal?.showModal) return;
      modal.showModal();
      const playback = modal.querySelector('video')?.play();
      playback?.catch(() => {});
    }));
    root.querySelectorAll('.cf-video-modal').forEach(modal => {
      modal.querySelector('[data-cf-close-video]').addEventListener('click',() => modal.close());
      modal.addEventListener('click',event => { if (event.target === modal) modal.close(); });
      modal.addEventListener('close',() => modal.querySelector('video')?.pause());
    });
    slides.forEach(slide => slide.addEventListener('click', event => {
      if (!dialog?.showModal) return;
      event.preventDefault(); dialog.querySelector('img').src = slide.href; dialog.showModal();
    }));
    dialog?.querySelector('[data-cf-close]').addEventListener('click',() => dialog.close());
    dialog?.addEventListener('click',event => { if (event.target === dialog) dialog.close(); });
  }
  function initDemos(scope) {
    scope.querySelectorAll('.cf-demo-video').forEach(tile => {
      if (tile.dataset.cfReady) return;
      tile.dataset.cfReady = 'true';
      const video = tile.querySelector('video');
      if (!video) return;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.controls = false;
      video.setAttribute('playsinline','');
      video.setAttribute('webkit-playsinline','');
      let visible = !('IntersectionObserver' in window);
      const play = () => { if (visible && !document.hidden && !document.querySelector('.cf-demo-modal[open]')) video.play()?.catch(() => {}); };
      video.addEventListener('loadeddata',play);
      video.addEventListener('canplay',play);
      if ('IntersectionObserver' in window) new IntersectionObserver(entries => entries.forEach(entry => { visible = entry.isIntersecting; if (visible) play(); else video.pause(); }),{threshold:.15}).observe(video);
      document.addEventListener('visibilitychange',() => { if (document.hidden) video.pause(); else play(); });
      document.addEventListener('touchend',play,{once:true,passive:true});
      tile.tabIndex = 0;
      tile.setAttribute('role','button');
      tile.setAttribute('aria-haspopup','dialog');
      const modal = document.createElement('dialog');
      modal.className = 'cf-video-modal cf-demo-modal';
      modal.setAttribute('aria-label',tile.getAttribute('aria-label') || '');
      const player = video.cloneNode(true);
      player.removeAttribute('autoplay');
      player.controls = true;
      player.muted = true;
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'cf-video-close';
      close.setAttribute('aria-label',tile.dataset.cfCloseLabel || '×');
      close.textContent = '×';
      modal.append(player,close);
      tile.closest('.cf-ideas').append(modal);
      const open = () => {
        if (!modal.showModal) return;
        document.querySelectorAll('.cf-demo-video video').forEach(item => item.pause());
        modal.showModal();
        player.play()?.catch(() => {});
      };
      tile.addEventListener('click',open);
      tile.addEventListener('keydown',event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); open(); } });
      close.addEventListener('click',() => modal.close());
      modal.addEventListener('click',event => { if (event.target === modal) modal.close(); });
      modal.addEventListener('close',() => { player.pause(); document.dispatchEvent(new Event('visibilitychange')); tile.focus({preventScroll:true}); });
      play();
    });
  }

  function initLocation() {
    const modal = document.querySelector('[data-cf-location-dialog]');
    if (!modal || modal.dataset.ready) return;
    modal.dataset.ready = 'true';
    const select = modal.querySelector('select[name="country_code"]');
    const input = modal.querySelector('[data-cf-postcode]');
    const key = country => 'cf-delivery-postcode-'+country;
    const read = country => { try { return localStorage.getItem(key(country)) || ''; } catch(e) { return ''; } };
    function sync() {
      const postcode = read(modal.dataset.country);
      const destination = modal.dataset.countryName+(postcode ? ' '+postcode : '');
      document.querySelectorAll('[data-cf-header-destination]').forEach(node => node.textContent = destination);
      document.querySelectorAll('[data-cf-delivery]').forEach(panel => {
        const node = panel.querySelector('[data-cf-delivery-destination]');
        if (node) node.textContent = panel.dataset.destinationTemplate.replace('__COUNTRY__',destination);
      });
    }
    function constraints() { input.pattern = select.value === 'AU' ? '[0-9]{4}' : '(?:[A-Za-z0-9 ]|-){2,12}'; input.inputMode = select.value === 'AU' ? 'numeric' : 'text'; }
    document.querySelectorAll('[data-cf-location-open]').forEach(button => button.addEventListener('click',() => {
      input.value = read(select.value);
      constraints();
      modal.showModal();
      input.focus();
    }));
    modal.querySelector('[data-cf-location-close]').addEventListener('click',() => modal.close());
    modal.addEventListener('click',event => { if(event.target === modal) modal.close(); });
    select.addEventListener('change',() => { input.value = read(select.value); constraints(); });
    modal.querySelector('form').addEventListener('submit',event => {
      const postcode = input.value.trim().toUpperCase();
      try { if (postcode) localStorage.setItem(key(select.value),postcode); else localStorage.removeItem(key(select.value)); } catch(e) {}
      if (select.value === modal.dataset.country) { event.preventDefault(); sync(); modal.close(); }
    });
    sync();
  }
  initLocation();
  document.addEventListener('shopify:section:load',initLocation);


  function initPredictiveSearch(scope) {
    scope.querySelectorAll('[data-cf-predictive-search]').forEach(form => {
      if (form.dataset.searchReady) return;
      form.dataset.searchReady = 'true';
      const input = form.querySelector('input[name="q"]');
      const panel = form.querySelector('.cf-search-suggestions');
      const status = form.querySelector('[data-cf-search-status]');
      let timer, controller, version = 0, selected = -1, lastQuery = '';
      const options = () => [...panel.querySelectorAll('[role="option"]')];
      function close() {
        panel.hidden = true;
        input.setAttribute('aria-expanded','false');
        input.removeAttribute('aria-activedescendant');
        selected = -1;
        options().forEach(node => node.setAttribute('aria-selected','false'));
      }
      function open() { panel.hidden = false; input.setAttribute('aria-expanded','true'); }
      async function search() {
        const query = input.value.trim();
        controller?.abort();
        const requestVersion = ++version;
        if (!query) { panel.replaceChildren(); lastQuery = ''; status.textContent = ''; close(); return; }
        if (lastQuery === query && panel.childElementCount) { open(); return; }
        controller = new AbortController();
        status.textContent = form.dataset.loading;
        try {
          const url = new URL(form.dataset.endpoint,location.origin);
          url.searchParams.set('q',query);
          url.searchParams.set('resources[type]','product');
          url.searchParams.set('resources[limit]','6');
          url.searchParams.set('resources[options][unavailable_products]','last');
          url.searchParams.set('section_id','eb-cf-predictive-search');
          const response = await fetch(url.toString(),{signal:controller.signal});
          if (!response.ok) throw new Error('Search unavailable');
          const html = await response.text();
          if (requestVersion !== version || input.value.trim() !== query) return;
          const result = new DOMParser().parseFromString(html,'text/html').querySelector('[data-cf-search-response]');
          if (!result) throw new Error('Missing search response');
          panel.replaceChildren(document.importNode(result,true));
          lastQuery = query;
          selected = -1;
          input.removeAttribute('aria-activedescendant');
          status.textContent = panel.querySelector('[data-cf-search-count]')?.textContent || '';
          if (form.contains(document.activeElement)) open();
        } catch(error) {
          if (error.name !== 'AbortError' && requestVersion === version) { close(); status.textContent = ''; }
        }
      }
      input.addEventListener('input',() => {
        clearTimeout(timer); controller?.abort(); version++;
        close();
        if (!input.value.trim()) { panel.replaceChildren(); lastQuery = ''; status.textContent = ''; return; }
        timer = setTimeout(search,180);
      });
      input.addEventListener('focus',() => { if(input.value.trim()) search(); });
      input.addEventListener('keydown',event => {
        if (event.key === 'Escape') { event.preventDefault(); clearTimeout(timer); controller?.abort(); version++; close(); return; }
        if (panel.hidden) return;
        const items = options();
        if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && items.length) {
          event.preventDefault();
          selected = (selected+(event.key === 'ArrowDown' ? 1 : -1)+items.length)%items.length;
          items.forEach((node,index) => node.setAttribute('aria-selected',String(index === selected)));
          input.setAttribute('aria-activedescendant',items[selected].id);
          items[selected].scrollIntoView({block:'nearest'});
        } else if(event.key === 'Enter' && selected >= 0 && items[selected]) {
          event.preventDefault(); items[selected].click();
        }
      });
      form.addEventListener('focusout',event => { if(!form.contains(event.relatedTarget)) close(); });
      document.addEventListener('click',event => { if(!form.contains(event.target)) close(); });
      form.addEventListener('submit',() => { clearTimeout(timer); controller?.abort(); close(); });
    });
  }
  initPredictiveSearch(document);
  document.addEventListener('shopify:section:load',event => initPredictiveSearch(event.target));

  initDemos(document);
  document.addEventListener('shopify:section:load',event => initDemos(event.target));
  document.querySelectorAll('[data-cf-product]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-cf-product]').forEach(init));
  document.addEventListener('click',event => {
    const scrollButton = event.target.closest('[data-cf-scroll]');
    if (scrollButton) {
      const track = scrollButton.closest('[data-cf-carousel]')?.querySelector('.cf-carousel-track');
      if (track) track.scrollBy({left: Number(scrollButton.dataset.cfScroll) * track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    document.querySelectorAll('.cf-desktop-nav details[open]').forEach(details => { if (!details.contains(event.target)) details.removeAttribute('open'); });
    const menu = document.querySelector('.cf-menu[open]');
    if (menu && !menu.contains(event.target)) menu.removeAttribute('open');
    const search = document.querySelector('.cf-search[open]');
    if (search && !search.contains(event.target)) search.removeAttribute('open');
  });
  document.addEventListener('keydown',event => { if (event.key === 'Escape') document.querySelectorAll('.cf-header details[open]').forEach(el => el.removeAttribute('open')); });
})();
